"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const KevinError_1 = require("./KevinError");
class KevinUnauthorizedError extends KevinError_1.default {
    constructor() {
        const errorName = 'Unauthorized';
        const errorMessage = 'Invalid clientId and/or clientSecret.';
        super(401, errorName, errorMessage);
        this.name = 'KevinUnauthorizedError';
    }
}
exports.default = KevinUnauthorizedError;
